<template>
  <div class="col-list">
    <!-- v-if="item.estate" -->
    <div v-for="(item, index) in houseList" :key="index">
      <div v-if="item.estate" class="col-property">
        <span v-if="$route.name == 'history'">
          <svg v-if="item.collectionID" class="icon col-icon" aria-hidden="true" @click="deleteCollection(item.collectionID, index, 'est')">
            <use xlink:href="#icon-myFavourites1"></use>
          </svg>
          <svg v-else class="icon col-icon del-icon" aria-hidden="true" @click="addCollection(index, item.estate.estateID, 'est')">
            <use xlink:href="#icon-shoucang1"></use>
          </svg>
        </span>
        <van-cell v-if="item.estate" @click="goUrl(item)">
          <van-card>
            <div slot="title" :class="['col-title', 'col-adress', { titCol: $route.name == 'history' }]">
              <!-- <span v-if="$route.name == 'history'">
              <svg v-if="item.collectionID" class="icon col-icon" aria-hidden="true" @click="deleteCollection(item.collectionID, index, 'est')">
                <use xlink:href="#icon-myFavourites1"></use>
              </svg>
              <svg v-else class="icon col-icon del-icon" aria-hidden="true" @click="addCollection(index, item.estate.estateID, 'est')">
                <use xlink:href="#icon-shoucang1"></use>
              </svg>
            </span> -->
              <span>{{ item.estate.estateName }}&nbsp;{{ item.estate.phaseWithCulture ? item.estate.phaseWithCulture : '' }}</span>
            </div>
            <!-- 图片部分 -->
            <div slot="thumb" class="col-card__thumb">
              <img class="img-hse" v-lazy="pub.imgResize(item.estate.defaultImage ? item.estate.defaultImage.imagePath : '', 'company')" onerror="errorImg(this)" />
              <div v-if="item.estate.isVideo">
                <svg class="icon reviewed" aria-hidden="true">
                  <use xlink:href="#icon-yingpian"></use>
                </svg>
              </div>
              <!-- vr图标的显示 -->
              <!-- <div v-if="item.estate.isVr">
              <img class="img-vr" src="../assets/ic_property_vr.gif" alt="">
            </div> -->
            </div>
            <div slot="desc" class="col-desc col-adress" v-if="item.estate.estateNameEN">
              <span>{{ item.estate.estateNameEN }}</span>
            </div>
            <div v-else slot="desc" class="col-desc col-adress"><span> &nbsp;</span></div>
            <!-- 地址 -->
            <div slot="tags" class="col-adress tagsblu">
              <img src="../assets/ditu.png" alt="" class="xf-img" />
              <span class="card-tags">{{ item.estate.detailAddressWithCulture }}</span>
            </div>
            <!-- 价单 面积 -->
            <div slot="price" class="bh-price">
              <div class="flexone">
                <div>
                  <p class="card-price col-adress" v-if="item.estate.dealAvgPrice">
                    <span>{{ lang.estateActual }}&nbsp;${{ item.estate.dealAvgPrice }}/{{ lang.chi }}</span>
                  </p>
                </div>
                <!-- 宗数 -->
                <div class="xiaozong" v-if="item.estate.dealSaleCount && language !== 'en-us'">
                  <span>{{ item.estate.dealAvgDateMonth }}{{ lang.monDeal }}{{ item.estate.dealSaleCount }}{{ lang.dealSaleCountUnit }}</span>
                </div>
                <div class="xiaozong" v-if="item.estate.dealSaleCount && language == 'en-us'">
                  <span>{{ lang.monDeal }}&nbsp;{{ changeEnmon(item.estate.dealAvgDateMonth) }}:{{ item.estate.dealSaleCount }}</span>
                </div>
              </div>
              <!-- 升降数据 -->
              <div class="ring-ratio">
                <div class="up" v-if="item.estate.dealAvgPriceRatio && item.estate.dealAvgPriceRatio > 0">
                  +{{ item.estate.dealAvgPriceRatio }}%
                  <div class="lvsan"></div>
                </div>
                <div class="down" v-else-if="item.estate.dealAvgPriceRatio && item.estate.dealAvgPriceRatio < 0">
                  {{ item.estate.dealAvgPriceRatio }}%
                  <div class="redsan"></div>
                </div>
              </div>
              <!-- <div class="xiaozong" v-if="item.estate.dealSaleCount">
              <span>{{ item.estate.dealAvgDateMonth }}月成交{{ item.estate.dealSaleCount }}{{ lang.dealSaleCountUnit }}</span>
            </div> -->
            </div>
            <!-- 航拍 租售数量 -->
            <div slot="footer" class="vr-buy-rent">
              <div class="vr-aerial">
                <span v-if="item.estate.isVr">{{ lang.vrFind }}</span>
                <span v-if="item.estate.isFly">{{ lang.aerial }}</span>
              </div>
              <div class="buy-rent">
                <!-- {{ item.estate.propertySaleCount  == 0 }}{{ item.estate.propertyRentCount  == 0 }} -->
                <!-- <span>&nbsp;</span> -->
                <span :class="['buy', { buyR: item.estate.propertyRentCount == 0 }]" v-if="item.estate.propertySaleCount">{{ lang.listBuy }}&nbsp;{{ item.estate.propertySaleCount }}</span>
                <span :class="['rent', { buyR: item.estate.propertySaleCount == 0 }]" v-if="item.estate.propertyRentCount">{{ lang.listRent }}&nbsp;{{ item.estate.propertyRentCount }}</span>
              </div>
            </div>
          </van-card>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import lang from '../../common/language/history';
import tool from '../../common/js/tools.js';
const _conf = require('../../common/js/_conf');

export default {
  data() {
    return {
      tool,
      ahou:false,
      lang: lang,
      shaiMonth: '',
      MONTH_EN_US: [
        { name: 'Jan.', val: '1' },
        { name: 'Feb.', val: '2' },
        { name: 'Mar.', val: '3' },
        { name: 'Apr.', val: '4' },
        { name: 'May.', val: '5' },
        { name: 'Jun.', val: '6' },
        { name: 'Jul.', val: '7' },
        { name: 'Aug.', val: '8' },
        { name: 'Sep.', val: '9' },
        { name: 'Oct.', val: '10' },
        { name: 'Nov.', val: '11' },
        { name: 'Dec.', val: '12' },
      ],
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
    };
  },
  props: {
    houseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  created() {
    this.lang.type = this.pub.getLang();
    this.loadCollectAll(1, 'Estate');
  },
  methods: {
    // 获取收藏屋苑
    loadCollectAll(index, type) {
      this.axios
        .post(this.pub.getApi().SearchCollection, {
          sourceType: type,
          pageCount: 100,
          pageIndex: index,
          isShowSourceInfo: true,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.ahou = false
            for (let i = 0; i < res.data.result.data.length; i++) {
              for (let z = 0; z < this.houseList.length; z++) {
                if (this.houseList[z]) {
                  if (this.houseList[z].estate.estateID == res.data.result.data[i].sourceID) {
                    this.$set(this.houseList[z], 'collectionID', res.data.result.data[i].collectionID);
                    this.ahou = true
                  }
                  if(!this.ahou){
                    this.$set(this.houseList[z], 'collectionID', '');
                  }
                }
              }
            }
            if (res.data.result.count > index * 100) {
              this.loadCollectAll(index + 1);
            }
          }
        });
    },
    // 英文月份
    changeEnmon(wuMon) {
      for (let i = 0; i < this.MONTH_EN_US.length; i++) {
        if (this.MONTH_EN_US[i].val == wuMon) {
          return this.MONTH_EN_US[i].name;
        }
      }
    },
    // 跳转详情页
    goUrl(item) {
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/';
      let name = item.estate.estateNameWithCulture
        .trim()
        .replace(/[^\u4e00-\u9fa5_a-zA-Z0-9\s]/g, '')
        .replace(/\s+/g, '-');
      let phase = item.estate.phaseWithCulture
        ? item.estate.phaseWithCulture
            .trim()
            .replace(/[^\u4e00-\u9fa5_a-zA-Z0-9\s]/g, '')
            .replace(/\s+/g, '-')
        : '';
      // location.href = `/${type}estate-${item.estate.estateID}.html`;
      location.href = `${base}/${type}estate-${item.estate.estateID}/${name}${phase}`;
    },
    addCollection(index, estateId, type) {
      this.$emit('newCollection', index, estateId, type);
    },
    deleteCollection(id, index, type) {
      this.$emit('cancelCollection', id, index, type);
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.van-card__price {
  width: 100%;
}
.van-card__header {
  min-height: 97px;
}
.col-list {
  margin-left: 15px;
  box-sizing: border-box;
  .col-icon {
    position: absolute;
    top: 17px;
    right: 32px;
    font-size: 20px;
  }
}
.col-property {
  height: 135px;
  position: relative;
  border-bottom: 1px solid #ebedf0;
}
.van-cell {
  padding: 15px 15px 6px 0;
  box-sizing: border-box;
  position: relative;
  top: 0;
  left: 0;
}
.col-title {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}
.titCol {
  width: 90%;
}
.col-desc {
  font-size: 11px;
  color: #999999;
  line-height: 13px;
}
.xf-img {
  width: 18px;
  height: 18px;
  vertical-align: -4px;
  margin-right: 3px;
}
.tagsblu {
  height: 21%;
  .card-tags {
    font-size: 12px;
    color: #4d73bf;
    line-height: 24px;
  }
}
.col-adress {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/* 图片部分 */
//  vr不展示
//  .img-vr{
//     width:36px !important;
//     height:36px !important;
//     position:absolute;
//     top: 50%;
//     left: 50%;
//     margin-left: -15px;
//     margin-top: -15px;
//   }
.van-card__thumb,
.col-card__thumb {
  width: 120px;
  height: 90px;
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  text-align: center;
  background: url('//static.house730.com/m/images/house-bg.png');
  background-size: cover;
}
.van-card__thumb {
  margin-right: 16px;
}
.van-card__thumb img {
  width: 120px;
  height: 90px;
  /* max-height: initial; */
}
.reviewed {
  font-size: 36px;
  position: absolute;
  left: 36%;
  bottom: 30%;
}
.col-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 20px;
  z-index: 5;
}
.del-icon {
  font-size: 24px;
}
.saled {
  font-size: 17px;
  color: #ffffff;
  opacity: 0.55;
  background: #292630;
  width: 120px;
  height: 90px;
  line-height: 90px;
  position: absolute;
  left: 0;
  top: 0;
}
/* 分类标签部分 */
.van-card {
  padding: 0 20px 0 0;
  background-color: #fff;
}
.van-ellipsis {
  overflow: inherit;
}
.van-card__content {
  text-align: left;
  height: auto;
}
.van-card__tag {
  top: 0;
}
.van-card__bottom,
.van-card__desc {
  line-height: 0;
}
.col-tag {
  color: #fff;
  background-image: linear-gradient(90deg, #ff3f4e 0%, #ff676d 100%);
  font-size: 10px;
  padding: 0 2px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  margin: 4px;
}
/* 价格部分 */
/* .new-price{
    width:100%;
}
.new-price p{
  height:40px;
  line-height:40px;
} */
.col-price {
  font-size: 14px;
  color: #333333;
}
.card-price {
  font-size: 13px;
  color: #ed1818;
  font-weight: 700;
}
.bh-price {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  // white-space: nowrap;
  line-height: 16px;
  color: #999;
  font-size: 14px;
  // display: flex;
  // justify-content: space-between;
  padding: 2px 0px;
  .flexone {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .ring-ratio {
    .up {
      position: absolute;
      right: 0;
      top: 0;
      color: #16ab7b;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      .lvsan {
        margin-left: 3px;
        border-style: solid;
        border-width: 6px 4px 6px 4px;
        border-color: transparent transparent #16ab7b transparent;
        width: 0px;
        height: 0px;
      }
    }
    .down {
      position: absolute;
      right: 0;
      top: 0;
      color: #e70e1a;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      .redsan {
        margin: 6px 0 0 3px;
        border-style: solid;
        border-width: 6px 4px 6px 4px;
        border-color: #e70e1a transparent transparent transparent;
        width: 0px;
        height: 0px;
      }
    }
  }
  .xiaozong {
    font-size: 12px;
    color: #333333;
    // position: absolute;
    // top: 76px;
    // left: 0;
  }
}
.vr-buy-rent {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .vr-aerial {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 120px;
    height: 17px;
    span {
      font-size: 12px;
      background-color: #056de0;
      color: #fff;
      padding: 0 5px;
      line-height: 17px;
      border-radius: 2px;
      margin-right: 2px;
    }
  }
  .buy-rent {
    width: 35%;
    height: 17px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    span {
      font-size: 12px;
      color: #fff;
      padding: 0 5px;
      line-height: 17px;
      border-radius: 2px;
      min-width: 45px;
      text-align: center;
    }
    .buy {
      background-color: #e70e1a;
      margin-right: 5px;
    }
    .buyR {
      margin-right: 0;
      margin-left: auto;
    }
    .rent {
      background-color: #106fc4;
    }
  }
}
.new-area {
  font-size: 11px;
  color: #999999;
}
/* .new-price .none-price{
  text-align:left;
  font-size:12px;
  color:#999999;
} */
</style>
